/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { vappContainer } from '@/application';
import { SignInPageService } from '@pages/SignInPage/services';
import { StorageModule } from '@vlinder-web/storage-module-react';
import toast from 'react-hot-toast';
const MODULE_NAME = 'profile.machines.states.signInUser';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

export const signInUser = async (context: any, event: any) => {
  const currentState = 'SIGN_IN_USER';
  const method = 'signIn';
  const storageSrv = StorageModule.getInstance();

  return new Promise(async (resolve, reject) => {
    try {
      const srv = getSrv();
      console.log(`next action in signIn:`, context['SEND_OTP']?.payload);
      let _payload = {
        ...event?.payload,
        nextAction: context['SEND_OTP']?.payload?.nextAction,
        role: context['SEND_OTP']?.payload.role,
      };
      const content = await srv.agent?.signInUser(_payload);
      if (content && content?.accessToken) {
        if (event?.payload?.rememberMe) {
          storageSrv.set('userProfile', content, 'local');
        } else {
          storageSrv.set('userProfile', content, 'session');
        }

        return resolve({
          key: 'SIGN_IN_USER_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else if (content && content?.signInToken) {
        if (event?.payload?.rememberMe) {
          storageSrv.set('userProfile', content, 'local');
        } else {
          storageSrv.set('userProfile', content, 'session');
        }
        return resolve({
          key: 'SIGN_IN_USER_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = content?.error;
        toast.error(msg);
        return reject({
          key: 'SIGN_IN_USER_FAILED',
          value: content,
        });
      }
    } catch (err: any) {
      toast.error(err?.message);
      return reject({
        key: 'SIGN_IN_USER_FAILED',
        value: 'Something went wrong please try again!',
      });
    }
  });
};
